import { Component, OnDestroy, OnInit } from '@angular/core';
import { IAppState } from '@myStore/app.state';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IGroup } from '@interfaces/IGroup';
import { selectGroups } from '@myStore/groups-view/groups-view.selector';
import {
  ClearGroups,
  GetGroupsRequest,
} from '@myStore/groups-view/groups-view.actions';
import { ChangeAttentionESDPGroupTrue } from '@myStore/groups-changes/groups-changes.actions';

@Component({
  selector: 'app-esdp-attention-list',
  templateUrl: './attention-esdp-list-component.html',
  styleUrls: ['./attention-esdp-list-component.sass'],
})
export class AttentionEdspListComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<boolean>();
  public groupsList$: IGroup[] = [];

  constructor(private _store: Store<IAppState>) {}

  ngOnInit(): void {
    this._store.dispatch(
      new GetGroupsRequest({
        is_active: 'true',
        will_transition_to_esdp: 'true',
      })
    );
    this._store
      .pipe(select(selectGroups), takeUntil(this.destroy$))
      .subscribe(groups => {
        if (groups) {
          this.groupsList$ = groups.results;
          this._store.dispatch(new ChangeAttentionESDPGroupTrue());
        }
      });
  }

  getRouteByStatusGroup(group: number | undefined): string {
    return `/courses-and-groups/courses/${group}`;
  }

  isEsdpGroupNotEmpty() {
    return this.groupsList$.length > 0;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this._store.dispatch(new ClearGroups());
  }
}
